var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "application-skills" }, [
    _c("div", { staticClass: "form-icon-input" }, [
      _c("div", [_c("Icon", { attrs: { icon: "search" } })], 1),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("VueSimpleSuggest", {
            ref: "autocomplete",
            attrs: {
              placeholder: _vm.computedKeywordPlaceholder,
              list: _vm.filteredItems,
              "min-length": 2,
              "value-attribute": "id",
              "display-attribute": "suggestion",
              styles: _vm.autoCompleteStyle,
              "max-suggestions": 0,
              debounce: 200,
              "prevent-submit": false,
              "prevent-hide": ""
            },
            on: {
              input: _vm.keywordChanged,
              "suggestion-click": _vm.itemClicked
            },
            nativeOn: {
              keyup: function($event) {
                return _vm.onEnter.apply(null, arguments)
              }
            },
            model: {
              value: _vm.keyword,
              callback: function($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    !_vm.hasSelectedItems
      ? _c(
          "div",
          { staticClass: "application-skills--none" },
          [
            _c(
              "b-form-checkbox",
              {
                on: { change: _vm.emitChangeEvent },
                model: {
                  value: _vm.none,
                  callback: function($$v) {
                    _vm.none = $$v
                  },
                  expression: "none"
                }
              },
              [_vm._v("\n\t\t\t" + _vm._s(_vm.noneText) + "\n\t\t")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.none
      ? _c(
          "div",
          { staticClass: "application-skills--items" },
          _vm._l(_vm.items, function(item) {
            return _c(
              "div",
              { key: item.id, staticClass: "application-skills--item" },
              [
                _c("div", [
                  item.freeText
                    ? _c("span", [_vm._v(_vm._s(item.freeText))])
                    : _c(
                        "span",
                        [
                          _c("Label", {
                            attrs: {
                              characteristic: item.item,
                              "label-type": _vm.labelType
                            }
                          })
                        ],
                        1
                      )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "font-size-smaller mb-1" }, [
                      _vm._v(_vm._s(_vm.labels.selfAssessmentTitle))
                    ]),
                    _vm._v(" "),
                    _c("Select", {
                      attrs: {
                        options: _vm.selfAssessmentOptions,
                        smaller: ""
                      },
                      on: { input: _vm.emitChangeEvent },
                      model: {
                        value: item.selfAssessment,
                        callback: function($$v) {
                          _vm.$set(item, "selfAssessment", $$v)
                        },
                        expression: "item.selfAssessment"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.remove(item)
                        }
                      }
                    },
                    [_c("Icon", { attrs: { icon: "bin" } })],
                    1
                  )
                ])
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }